import { Button, Modal } from 'antd'
import styles from './index.module.scss'
import './index.scss'
import exclamationIcon from 'src/assets/svgs/icon-exclamation.svg'

interface ConfirmModalProps {
  visible: boolean
  title?: string
  content?: string
  cancelLabel?: string
  confirmLabel?: string
  handleCancel: () => void
  handleConfirm: () => void
}

export function ConfirmModal({
  visible,
  title,
  content = '',
  cancelLabel = 'Cancel',
  confirmLabel = 'Confirm',
  handleCancel,
  handleConfirm
}: ConfirmModalProps) {
  return (
    <Modal
      visible={visible}
      onOk={handleConfirm}
      onCancel={handleCancel}
      footer={ [  
              <Button key="back" onClick={handleCancel}>  
                {cancelLabel}  
              </Button>,  
              <Button  
                key="submit"  
                style={{  
                  backgroundColor: '#ca4a04',  
                  color: '#fff',  
                  borderColor: '#ca4a04',  
                }}  
                onClick={handleConfirm}  
              >  
                {confirmLabel}  
              </Button>,  
            ]  
      } 
      wrapClassName="confirm-modal-root"
    >
      <div className={styles.title}>
        <img className={styles.icon} src={exclamationIcon} alt="" />
        {title ? title : 'Are you sure?'}
      </div>
      <div className={styles.content}>{content}</div>
    </Modal>
  )
}
